import React from 'react';
import PropTypes from 'prop-types';

import {
  Box,
  Card,
  Typography
} from '@mui/material';

const TemplateContentWrapper = ({
  title,
  children
}) => {
  return (
    <Card
      elevation={0}
      sx={{
        width: '100%',
        height: '100%',
        minHeight: 0,

        p: 1.5,
        py:2.5,

        display: 'flex',
        flexDirection: 'column',

        border: '1px solid #E3E3E3',
        borderRadius: '8px',

        boxShadow:
          '0 1px 3px rgba(0, 0, 0, 0.08)',

        bgcolor: '#FFFFFF',

        overflow: 'hidden'
      }}
    >
      {/* Title */}

      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',

          flexShrink: 0,

          mb:2.5
        }}
      >
        <Typography
          sx={{
            fontSize: 16,
            fontWeight: 500,
            color: '#424242'
          }}
        >
          {title}
        </Typography>
      </Box>

      {/* Content */}

      <Box
        sx={{
          flex: 1,
          minHeight: 0,

          display: 'flex',

          overflow: 'hidden'
        }}
      >
        {children}
      </Box>
    </Card>
  );
};

TemplateContentWrapper.propTypes = {
  title: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired
};

export default TemplateContentWrapper;